import React from "react";
import { Handshake, ShieldCheck, Clock, FileCheck } from "lucide-react";
import PillarPage from "../components/PillarPage";

const content = {
  kicker: "Agency Acquisitions",
  title: "A considered home for estate and letting agencies.",
  subtitle:
    "If you own an estate or letting agency and are thinking about the future, OTP Group offers a straightforward route to a confidential, well-structured sale, and a lasting home for the business you have built.",

  criteriaKicker: "What we look for",
  criteriaTitle: "Businesses we acquire.",
  criteriaIntro:
    "We are a long-term acquirer rather than a short-term trade buyer. We are most interested in well-run agencies where continuity matters to the owner.",
  criteria: [
    "Independent estate or letting agencies, or established franchise offices.",
    "A meaningful lettings and property management book.",
    "A defined local market and a recognised local reputation.",
    "A capable team that wishes to remain with the business.",
  ],

  whyKicker: "Why sell to us",
  whyTitle: "A straightforward, respectful process.",
  whyBlocks: [
    {
      icon: Handshake,
      title: "A genuine long-term home",
      text: "We buy to hold. Your clients, staff and local presence continue rather than being stripped out or rebranded overnight.",
    },
    {
      icon: ShieldCheck,
      title: "Continuity for your team",
      text: "We work to retain the people and relationships that made the business successful in the first place.",
    },
    {
      icon: Clock,
      title: "Certainty and pace",
      text: "Because our funding is arranged in advance, we can move quickly and give you clarity at every stage.",
    },
    {
      icon: FileCheck,
      title: "Fair, clear terms",
      text: "We structure consideration transparently, typically combining an upfront payment with deferred elements agreed with you.",
    },
  ],

  processKicker: "Our process",
  processTitle: "From first conversation to completion.",
  steps: [
    { title: "Confidential conversation", text: "An informal, no-obligation discussion to understand your business and your objectives." },
    { title: "Indicative terms", text: "We review the key information and set out an indicative offer and structure." },
    { title: "Due diligence", text: "A focused, proportionate review of the business, handled discreetly." },
    { title: "Completion & integration", text: "We complete the transaction and integrate the business carefully, protecting continuity." },
  ],

  proofKicker: "Track record",
  proofTitle: "Brands within the group.",
  proofIntro:
    "OTP Group already owns established agency brands, giving sellers the confidence that their business is joining an experienced operator.",
  proofItems: [
    {
      name: "Northwood",
      logo: "/brands/northwood.png?v=3",
      text: "A national lettings and estate agency network, the UK's leading provider of Guaranteed Rent.",
    },
    {
      name: "Martin & Co",
      logo: "/brands/martinco.png?v=3",
      text: "A well-recognised residential lettings and sales brand with a broad presence across the United Kingdom.",
    },
  ],

  ctaTitle: "Considering a sale?",
  ctaText:
    "Every conversation is confidential and without obligation. If you are considering the future of your agency, we would welcome an introduction.",
  ctaButtonLabel: "Start a conversation",
  ctaTo: "/contact?path=agency-sale",
};

const AgencyAcquisitions = () => <PillarPage content={content} />;

export default AgencyAcquisitions;
